function displayToastWithMessage(type, message) {
    let ele = $("#toast-" + type);
    ele.toast("show");
    ele.find(".toast-body").text(message);
}

function displayErrorToast() {
    $("#toast-error").toast("show");
}

function displayWarningToast() {
    $("#toast-warning").toast("show");
}

function displaySuccessToast() {
    $("#toast-success").toast("show");
}

export { displayToastWithMessage, displayErrorToast, displaySuccessToast, displayWarningToast };
